export function onInitSymptomsTest() {
    $('#age-input').on('keypress', function (evt) {
        var iKeyCode = (evt.which) ? evt.which : evt.keyCode
        if (iKeyCode != 46 && iKeyCode > 31 && (iKeyCode < 48 || iKeyCode > 57))
            return false;

        return true;
    });

    $('.back-btn').click(function(e) {
        window.scrollTo(0, 0);
    })
}










